// src/services/parkingService.js


// const baseUrl = process.env.VUE_APP_HTTP_BASE_URL;
const baseUrl = process.env.VUE_APP_TWPK_API_URL;
const billbaseUrl = process.env.VUE_APP_TWPK_BILL_API_URL;

/**
 * Sends a POST request using the Fetch API.
 * @param {string} url - The endpoint URL.
 * @param {object} payload - The request payload.
 * @returns {Promise<object>} - Resolves with the response data.
 */
async function postRequest(url, payload) {
    try {
        console.log(`Sending POST request to ${url} with payload:`, payload);
        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
                // Add other headers here if necessary (e.g., Authorization)
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        console.log(`Received response with status ${response.status}:`, data);

        if (response.ok) {
            return data;
        } else {
            throw new Error(`Request failed with status ${response.status}: ${data.Message || 'Unknown error'}`);
        }
    } catch (error) {
        console.error(`Error during POST request to ${url}:`, error.message);
        throw error;
    }
}



/**
 * Queries the parking fee for a given parking session and plate number.
 * @param {string} baseUrl - The base URL for the API (e.g., "https://172.233.151.241/ada").
 * @param {string} parking_id - The unique identifier for the parking session.
 * @param {string} plate_number - The vehicle's plate number.
 * @returns {Promise<number>} - Resolves with the parking fee.
 */
export async function queryParkingFee( parking_id, plate_number, longitude, latitude) {
    const url = `${baseUrl}/get_parking_fee`;
    const payload = {
        parking_id: parking_id,
        plate_number: plate_number,
        longitude: longitude,
        latitude: latitude
    };

    try {
        const data = await postRequest(url, payload);
        console.log(data);
        // Adjust based on actual response structure
        if (data.fee !== undefined) {
            return data;
        } else {
            throw new Error('parking_fee not found in response');
        }
    } catch (error) {
        console.error("Failed to query parking fee:", error.message);
        throw error;
    }
}



/**
 * 依車號查詢停車事件。
 * longitude / latitude 為選填：有帶時後端會以該座標就近搜尋（DistanceMax 50 公里），
 * 未帶時後端沿用全台預設範圍（台灣中心點 + 190 公里）。
 */
export async function getEvents( plate_number, longitude, latitude, coordStatus) {
    const url = `${baseUrl}/get_events`;
    const payload = {
        plate_number: plate_number,
    };
    if (longitude !== undefined && longitude !== null && longitude !== ''
        && latitude !== undefined && latitude !== null && latitude !== '') {
        payload.longitude = String(longitude);
        payload.latitude = String(latitude);
    }
    // 後端不使用此欄位，但 app.py 會把整個 request 印進日誌，
    // 用來分辨「沒帶座標」究竟是拒絕授權、非安全來源還是逾時
    if (coordStatus) {
        payload.coord_status = String(coordStatus);
    }

    try {
        const data = await postRequest(url, payload);
        console.log(data);
        // Adjust based on actual response structure
        if (data.fee !== undefined) {
            return data;
        } else {
            throw new Error('parking_fee not found in response');
        }
    } catch (error) {
        console.error("Failed to query parking fee:", error.message);
        throw error;
    }
}



/**
 * Applies a discount to the parking fee for a given parking session.
 * @param {string} baseUrl - The base URL for the API (e.g., "https://172.233.151.241/ada").
 * @param {string} session_id - The unique identifier for the parking session.
 * @param {number} park_fee - The parking fee to apply the discount to.
 * @returns {Promise<number>} - Resolves with the residual parking fee after discount.
 */
export async function doCardDiscount( session_id, park_fee, card_no, expire_date, parking_start_time, agreement_id) {
    const url = `${baseUrl}/do_card_discount`;
    const payload = {
        session_id: session_id,
        park_fee: park_fee,
        card_no: card_no,
        expire_date: expire_date,
        parking_start_time: parking_start_time,
        agreement_id: agreement_id || "ESTP9999"
    };

    try {
        const data = await postRequest(url, payload);
        // Adjust based on actual response structure

        if (data.residual_fee !== undefined) {
            // return data.residual_fee;
            return data;
        }

        // 後端用 reason 表達「需要前端出面處理」的狀況（金額變動、要重新查詢…），
        // 這類回應要原樣交給呼叫端判斷，不能當成一般錯誤丟出去。
        if (data.reason) {
            console.log("doCardDiscount reason:", data.reason, data);
            return data;
        }

        // throw new Error('residual_fee not found in response');
        console.log("doCardDiscount response:", data);
        throw data.message || 'Unknown error';
    } catch (error) {
        console.error("Failed to apply card discount:", error.message);
        throw error;
    }
}


export async function closeSessionX( session_id) {
    const url = `${baseUrl}/close_session`;
    const payload = {
        session_id: session_id
    };

    try {
        const data = await postRequest(url, payload);
        // Adjust based on actual response structure
        if (data.success) {
            // return data.residual_fee;
            return data;
        } else {
            throw new Error('Failed to close session');
        }
    } catch (error) {
        console.error("Failed to close session", error.message);
        throw error;
    }
}



export async function closeSession( parking_id, lp_id) {
    const url = `${billbaseUrl}/api/TransactionClose`;
    const payload = {
        // session_id: session_id
        DepID: parking_id,
        CarNO: lp_id

    };

    try {
        const data = await postRequest(url, payload);
        // Adjust based on actual response structure
        if (data.status ==="success") {
            // return data.residual_fee;
            return data;
        } else {
            throw new Error('Failed to close session');
        }
    } catch (error) {
        console.error("Failed to close session", error.message);
        throw error;
    }
}




/**
 * Applies a discount to the parking fee for a given parking session.
 * @param {string} baseUrl - The base URL for the API (e.g., "https://172.233.151.241/ada").
 * @param {string} session_id - The unique identifier for the parking session.
 * @param {number} park_fee - The parking fee to apply the discount to.
 * @returns {Promise<number>} - Resolves with the residual parking fee after discount.
 */
export async function doCardDiscountGlobal( event_id, field_no, plate_number, park_fee, card_no, expire_date, parking_start_time, agreement_id) {
    const url = `${baseUrl}/do_card_discount_global`;
    const payload = {
        event_id: event_id,
        field_no: field_no,
        plate_number: plate_number,
        park_fee: park_fee,
        card_no: card_no,
        expire_date: expire_date,
        parking_start_time: parking_start_time,
        agreement_id: agreement_id || "ESTP9999"
    };

    try {
        const data = await postRequest(url, payload);
        // Adjust based on actual response structure

        if (data.residual_fee !== undefined) {
            // return data.residual_fee;
            return data;
        } else {
            // throw new Error('residual_fee not found in response');
            console.log("doCardDiscount response:", data);
            throw data.message || 'Unknown error';
        }
    } catch (error) {
        console.error("Failed to apply card discount:", error.message);
        throw error;
    }
}
